<template lang="pug">
  v-app-bar(fixed app dense color="#2C3A47" flat)

    //v-toolbar-title(class="grey--text headline text-uppercase") {{ $t('toolbar.TITLE') }}
    v-toolbar-title
      v-img(src="../../../public/semsenha-2019-bk.svg" aspect-ratio="4" width="136" contain)
    TopLoading

    //div(class="flex-grow-1")

    //v-btn(icon)
      v-icon(class="white--text") mdi-magnify

    v-layout(row)
      v-spacer
      LocaleChanger
      HotspotChanger(v-if="isTokenSet")

      v-menu(bottom origin="center center" transition="scale-transition" offset-y v-if="isTokenSet")
        template(v-slot:activator="{ on }")
          v-btn(color="#2C3A47" class="white--text" v-on="on")
            v-icon mdi-account-outline

        v-list
          v-list-item(@click="")
            v-list-item-title(v-if="isTokenSet" @click="userLogout")
              v-list-item-action
                v-icon mdi-exit-to-app
              span {{ $t('menuItems.LOGOUT') }}

          v-list-item
            v-list-item-title(v-if="isTokenSet" @click="$router.push('/profile')")
              v-list-item-action
                v-icon mdi-account
              span {{ $t('menuItems.MY_PROFILE') }}


    template(v-slot:extension v-if="isTokenSet")
      v-tabs(show-arrows color="#2C3A47")
        v-tabs-slider(color="secondary")
        v-tab(v-for="(item) in menuItems" :to="{ name: item.link }") {{ item.title }} <!-- Usuário comum logado -->
        v-tab(v-if="admin || superAdm" v-for="(item) in adminItems" :to="{ name: item.link }") {{ item.title }}<!-- Super Administrador -->
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
import HotspotChanger from '@/components/core/HotspotChanger'
import LocaleChanger from '@/components/core/LocaleChanger'
import TopLoading from '@/components/core/TopLoading.vue'

  export default {
    name: 'Toolbar',
    data: () => ({
      selectedHotspot: '',
      computed: mapGetters(['showTopLoading'])
    }),
    computed: {
      ...mapGetters(['isTokenSet', 'user']),
      userName() {
        return this.user.name
      },
      admin() { // verifica se usuário é administrador
        return this.user !== null ? this.user.role === 'admin' : false
      },
      superAdm() { // verifica se usuário é administrador
        return this.user !== null ? this.user.role === 'super' : false
      },

      adminItems() {
        return [
          {
            title: this.$t('subToolbar.ADMINUSERS'),
            link: 'admin-users',
          },
          {
            title: this.$t('subToolbar.SOCIAL'),
            link: 'social-all',
          },
          {
            title: this.$t('subToolbar.ACCESSCONTROL'),
            link: 'admin-access',
          },
          // {
          //   title: this.$t('subToolbar.DASHBUS'),
          //   link: 'dash-bus',
          // }
        ]
      },
      menuItems() {
        if (this.isTokenSet) { // usuário logado
          return [
            {
              title: this.$t('subToolbar.DASH'),
              link: 'dashboard',
            },
            {
              title: this.$t('subToolbar.ADS'),
              link: 'adminads',
            },
            {
              title: this.$t('subToolbar.CLIENTS'),
              link: 'clients',
            },
            {
              title: this.$t('subToolbar.MARKETING'),
              link: 'mail',
            }
          ]
        }
        return [ // usuário deslogado
          {
            title: 'usuário deslogado...',
            link: 'landing',
            icon: 'mdi-home'
          }
        ]
      }
    },
    components: {
        HotspotChanger,
        LocaleChanger,
        TopLoading
    },
    methods: {
      ...mapActions(['setHotspot']),
      userLogout() {
        this.$store.dispatch('userLogout')
      }
      // setSelectedHotspot(){
      //   if(window.localStorage.getItem('selectedHotspot') != null){
      //     this.selectedHotspot = window.localStorage.getItem('selectedHotspot').split('"').join('')
      //   }else{ this.selectedHotspot = window.localStorage.getItem('selectedHotspot') }
      // }

    },
    //mounted(){ this.userLogout() }
  }

</script>
